export default {
    es: {
        CARD_NUMBER: 'Número de tarjeta',
        NUMBER: 'Número',
        DATE_FORMAT: 'MM/AA',
        CVV: 'CVV',
        CCNUMBER_ERROR: 'El número de tarjeta no es correcto',
        EXP_ERROR: 'La fecha de expiración es inválida.',
        CVV_ERROR: 'El código de seguridad no es correcto.',
        HOLDER_NAME_ERROR: 'El nombre del titular no es correcto.'
    },
    en: {
        CARD_NUMBER: 'Card number',
        NUMBER: 'Number',
        DATE_FORMAT: 'MM/YY',
        CVV: 'CVV',
        CCNUMBER_ERROR: 'The card number is incorrect.',
        EXP_ERROR: 'The card expiration date is incorrect.',
        CVV_ERROR: 'The card security code is incorrect.',
        HOLDER_NAME_ERROR: 'The card owner’s name is incorrect.'
    },
    pt: {
        CARD_NUMBER: 'Número do cartão',
        NUMBER: 'Número',
        DATE_FORMAT: 'MM/AA',
        CVV: 'CVV',
        CCNUMBER_ERROR: 'O número do cartão está incorreto.',
        EXP_ERROR: 'A data de expiração do cartão está incorreta.',
        CVV_ERROR: 'O código de segurança do cartão está incorreto.',
        HOLDER_NAME_ERROR: 'O nome do titular não está correto.'
    },
    zh: {
        CARD_NUMBER: '信用卡号',
        NUMBER: '数',
        DATE_FORMAT: 'MM/YY',
        CVV: 'CVV',
        CCNUMBER_ERROR: '卡号不正确',
        EXP_ERROR: '卡的到期日期不正确',
        CVV_ERROR: '卡的安全代码不正确',
        HOLDER_NAME_ERROR: '卡的旧名称不正确'
    },
    cv: {
        CARD_NUMBER: 'kart numarası',
        NUMBER: 'numarası',
        DATE_FORMAT: 'AA/YY',
        CVV: 'CVV',
        CCNUMBER_ERROR: 'Kart numarası yanlış.',
        EXP_ERROR: 'Kartın son kullanma tarihi yanlış.',
        CVV_ERROR: 'Kartın güvenlik kodu yanlış.',
        HOLDER_NAME_ERROR: 'Kartın eski adı yanlış'
    },
    tr: {
        CARD_NUMBER: 'kart numarası',
        NUMBER: 'numarası',
        DATE_FORMAT: 'AA/YY',
        CVV: 'CVV',
        CCNUMBER_ERROR: 'Kart numarası yanlış.',
        EXP_ERROR: 'Kartın son kullanma tarihi yanlış.',
        CVV_ERROR: 'Kartın güvenlik kodu yanlış.',
        HOLDER_NAME_ERROR: 'Kartın eski adı yanlış'
    },
    ar: {
        CARD_NUMBER: 'رقم البطاقة',
        NUMBER: 'الرقم',
        DATE_FORMAT: 'MM/YY',
        CVV: 'CVV',
        CCNUMBER_ERROR: 'رقم البطاقة غير صحيح.',
        EXP_ERROR: 'تاريخ انتهاء صلاحية البطاقة غير صحيح.',
        CVV_ERROR: 'رمز أمان البطاقة غير صحيح.',
        HOLDER_NAME_ERROR: 'الاسم القديم للبطاقة غير صحيح'
    },
    fr: {
        CARD_NUMBER: 'Numéro de carte',
        NUMBER: 'Nombre',
        DATE_FORMAT: 'MM/AA',
        CVV: 'CVV',
        CCNUMBER_ERROR: 'Le numéro de carte est incorrect.',
        EXP_ERROR: 'La date d’expiration de la carte est incorrecte.',
        CVV_ERROR: 'Le code de sécurité de la carte est incorrect.',
        HOLDER_NAME_ERROR: 'L’ancien nom de la carte est incorrect'
    }
};
